import { render } from "./createRate.vue?vue&type=template&id=115711fe&scoped=true"
import script from "./createRate.vue?vue&type=script&lang=js"
export * from "./createRate.vue?vue&type=script&lang=js"

import "./createRate.vue?vue&type=style&index=0&id=115711fe&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115711fe"]])

export default __exports__